import { Telemetry } from 'core/models/FMS/Telemetry';
import { Vehicle } from 'core/models/vehicle';
import { VehicleTelemetryRepository } from 'core/repositories/FMS/VehicleTelemetryRepository';
import { KeyedListenerManager } from 'utility/KeyedListenerManager';
import { FMSWebsocketAPI, VehicleTelemetry } from './api/FMS/ws';

export class VehicleTelemetryRepositoryImpl implements VehicleTelemetryRepository {
    private disposed = false;

    private readonly onReconnect = () => {
        this.listenersManager.keys().forEach(vehicleId => {
            this.api.subscribeVehicleTelemetry(vehicleId);
        });
    };

    constructor(public readonly api: FMSWebsocketAPI) {
        this.api.addEventListener('reconnect', this.onReconnect);
    }

    async dispose() {
        if (this.disposed) return;
        this.api.removeEventListener('reconnect', this.onReconnect);
        this.listenersManager.clear();
        this.disposed = true;
    }

    addTelemetryListener(vehicleId: Vehicle.Id, listener: (telemetry: Telemetry) => void): void {
        if (this.disposed) return;
        this.listenersManager.addListener(vehicleId, listener);
    }

    removeTelemetryListener(vehicleId: Vehicle.Id, listener: (telemetry: Telemetry) => void): void {
        if (this.disposed) return;
        this.listenersManager.removeListener(vehicleId, listener);
    }

    private readonly listenersManager = new KeyedListenerManager<Vehicle.Id, (telemetry: Telemetry) => void>((vehicleId, listeners) => {
        const listener = (vehicleTelemetry: VehicleTelemetry) => listeners.forEach(listener => listener(vehicleTelemetry));

        this.api.addEventListener('vehicleTelemetry', listener);
        this.api.subscribeVehicleTelemetry(vehicleId);

        return () => {
            this.api.unsubscribeVehicleTelemetry(vehicleId);
            this.api.removeEventListener('vehicleTelemetry', listener);
        };
    });
}
